import { useOrganization } from 'hooks';
import { useFeatureFlags } from 'utils/features';

export default function useProgressValueEnabled() {
  const workAccomplishedEnabled = useFeatureFlags('WORK_ACCOMPLISHED');
  const { trackCostCode, trackBudgetProgress, trackBudgetProgressValue } = useOrganization();
  return trackCostCode && trackBudgetProgress && trackBudgetProgressValue && workAccomplishedEnabled;
}
